export default "__VITE_ASSET__DgAfgekb__"